import { WorkPackageStats, UnitOfMeasure } from '@bechtel/types';

export const CommittedMilestoneStatsMock: WorkPackageStats['committedMilestones'] = {
  id: '',
  numMilestones: 0,
  hours: 0,
  quantity: {
    quantity: 0,
    unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
  },
};
